export const getMentorCalls = ({ page = 1, tab, per_page: perPage } = {}) => {
  const params = new URLSearchParams({ page });
  if (tab) params.set('tab', tab);
  if (perPage) params.set('per_page', perPage);
  return fetch(`/api/v2/calls?${params.toString()}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });
};

export const getBlockedSlots = (conversationId) =>
  fetch(`/api/v2/conversations/${conversationId}/calls/blocked_slots`, {
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const createCall = (conversationId, params = {}) =>
  fetch(`/api/v2/conversations/${conversationId}/calls`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ call: params }),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const createCallSuggestion = (conversationId) =>
  fetch(`/api/v2/conversations/${conversationId}/call_suggestions`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const getCall = (conversationId, callId) =>
  fetch(`/api/v2/conversations/${conversationId}/calls/${callId}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const updateCall = (conversationId, callId, params = {}) =>
  fetch(`/api/v2/conversations/${conversationId}/calls/${callId}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    body: JSON.stringify(params),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const cancelCall = ({ callId } = {}) =>
  fetch(`/api/v2/calls/${callId}/cancel`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const acceptCall = ({ callId, scheduledAt } = {}) =>
  fetch(`/api/v2/calls/${callId}/accept`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    body: JSON.stringify({ scheduled_at: scheduledAt }),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const declineCall = ({ callId } = {}) =>
  fetch(`/api/v2/calls/${callId}/decline`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const getCallByToken = (token) =>
  fetch(`/api/v2/calls/show/${token}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const cancelCallByToken = (token) =>
  fetch(`/api/v2/calls/cancel/${token}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const acceptCallByToken = (token, scheduledAt) =>
  fetch(`/api/v2/calls/accept/${token}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(scheduledAt ? { scheduled_at: scheduledAt } : {}),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

export const counterCallByToken = (token, proposedSlots) =>
  fetch(`/api/v2/calls/counter/${token}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ call: { proposed_slots: proposedSlots } }),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });

const readJson = (response) => {
  if (!response.ok) {
    return response.json().then((data) => {
      throw new Error(data.error || 'Request failed');
    });
  }
  return response.json();
};

export const getRescheduleCall = (token) =>
  fetch(`/api/v2/calls/reschedule/${token}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(readJson);

export const cancelRescheduleCall = (token) =>
  fetch(`/api/v2/calls/reschedule/${token}/cancel`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).then(readJson);

export const createRescheduleCall = (token, params = {}) =>
  fetch(`/api/v2/calls/reschedule/${token}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ call: params }),
  }).then(readJson);

export const declineCallByToken = (token) =>
  fetch(`/api/v2/calls/decline/${token}`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.error || 'Request failed');
      });
    }
    return response.json();
  });
